<template>
    <v-navigation-drawer
      app
      clipped
      v-model="DRAWER_STATE"
      absolute
      :width="sidebarWidth"
    >
      <v-list shaped>
          <template v-for="(category, categoryIndex) in $store.getters['auth/getNavMenuCategoryList']">
            <v-row v-if="category" :key="category" align="center">
              <v-col cols="12" :class="DRAWER_STATE ? 'text-left' : 'text-center'">
                <span
                  v-if="category"
                  :class="(DRAWER_STATE ? 'text-caption subheader pl-4' : 'text-caption subheader') + ' info--text font-weight-bold'"
                >
                  {{ category }}
                </span>
              </v-col>
            </v-row>
            <template v-for="(menu) in $store.getters['auth/getNavMenu'].filter(x => x.webMenuCategory === category)">
              <template
                v-if="menu.subMenuList === null"
              >
                <v-list-item
                  color="primary"
                  :title="menu.webMenuCaption"
                  :key="'web-menu-' + menu.webMenuId"
                  :to="menu.path"
                  link
                  exact
                  exact-active-class="lightgrey primary--text"
                >
                  <v-list-item-action>
                    <v-icon :color="menu.color ? item.color : 'black'">{{
                      menu.mdiIcon ? menu.mdiIcon : 'mdi-checkbox-blank-circle-outline'
                    }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title 
                      class="text-body-2 subheader black--text" 
                      link
                    >
                      {{ menu.webMenuCaption }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template
                v-else
              >
                <v-list-group
                  v-if="menu.subMenuList"
                  color="primary"
                  :title="menu.webMenuCaption"      
                  :key="menu.webMenuCaption"
                  v-model="menu.collapsed"
                >
                  <template v-slot:prependIcon>
                    <v-icon size="20" color="black">{{ menu.mdiIcon ? menu.mdiIcon : 'mdi-checkbox-blank-circle-outline' }}</v-icon>
                  </template>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 subheader black--text">
                        {{ menu.webMenuCaption }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="(subMenu, i) in menu.subMenuList"
                    :title="subMenu.webMenuCaption"
                    :key="'sub-menu-' + i"
                    :to="subMenu.path"
                    link
                    exact
                    exact-active-class="lightgrey primary--text"
                  >
                    <v-list-item-action v-if="subMenu.mdiIcon">
                      <v-icon :class="(DRAWER_STATE ? '' : 'ml-4') + ' black--text'" size="16">{{ subMenu.mdiIcon ? subMenu.mdiIcon : 'mdi-checkbox-blank-circle-outline' }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 subheader black--text">
                        {{ subMenu.webMenuCaption }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </template>
            </template>
            <v-divider
              v-if="categoryIndex < $store.getters['auth/getNavMenuCategoryList'].length - 1"
              :key="`${category}-${categoryIndex}`"
              dark
              style="width: 90%"
              class="my-4 mx-auto"
            ></v-divider>
          </template>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(['drawer']),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
      set(newValue) {
        if (newValue === this.drawer) return;
        else this.$store.dispatch('toggleDrawer');
      }
    }
  },
  data() {
    return {
      sidebarWidth: 300,
      sidebarMinWidth: 96,
    };
  },
};
</script>

<style src="@/styles/VerticalNavMenu.scss" lang="scss">